import { render } from "./HODSingleClaimComponent.vue?vue&type=template&id=689d1db5&scoped=true"
import script from "./HODSingleClaimComponent.vue?vue&type=script&lang=js"
export * from "./HODSingleClaimComponent.vue?vue&type=script&lang=js"

import "./HODSingleClaimComponent.vue?vue&type=style&index=0&id=689d1db5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689d1db5"]])

export default __exports__